"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProgressBar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _utils = require("../utils");

var _styles = require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ProgressBar = function ProgressBar(_ref) {
  var color = _ref.color,
      value = _ref.value,
      className = _ref.className,
      size = _ref.size,
      small = _ref.small,
      limit = _ref.limit,
      label = _ref.label,
      comment = _ref.comment;
  var classes = (0, _styles.useStyles)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      success = _useState2[0],
      setSuccess = _useState2[1];

  var handleClass = function handleClass() {
    if (limit && success) {
      return classes.readerBarP;
    }

    if (!limit && success) {
      return classes.barSuccess;
    }

    return classes.bar;
  };

  (0, _react.useEffect)(function () {
    if (value === 100) {
      setSuccess(true);
    } else {
      setSuccess(false);
    }
  }, [value, setSuccess]);
  if (label || comment) return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.wrapper,
    style: {
      width: (0, _utils.checkSize)(size)
    }
  }, label && /*#__PURE__*/_react.default.createElement("p", {
    className: classes.label
  }, label), /*#__PURE__*/_react.default.createElement(_core.LinearProgress, {
    style: {
      height: "".concat(small ? '10px' : '24px')
    },
    classes: {
      root: classes.root,
      bar: handleClass()
    },
    variant: "determinate",
    value: value,
    color: "secondary",
    className: className,
    limit: limit
  }), comment && /*#__PURE__*/_react.default.createElement("p", {
    className: classes.comment
  }, comment));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.LinearProgress, {
    style: {
      width: (0, _utils.checkSize)(size),
      height: "".concat(small ? '10px' : '24px')
    },
    classes: {
      root: classes.root,
      bar: handleClass()
    },
    variant: "determinate",
    value: value,
    color: color,
    className: className,
    limit: limit
  }));
};

exports.ProgressBar = ProgressBar;
ProgressBar.propTypes = {
  /**
   * Cor do ProgressBar
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']),

  /**
   * Object classes
   */
  className: _propTypes.default.string,

  /**
   * Valor do indicador de progesso, varia de 0 a 100
   */
  value: _propTypes.default.number.isRequired,

  /**
   * Seleciona o tamanho do progressBar
   */
  size: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'full']),

  /**
   * Se 'True', a progress bar tem uma altura menor
   */
  small: _propTypes.default.bool,

  /**
   * Se 'True', a cor de 100% se torna cinza
   */
  limit: _propTypes.default.bool,

  /**
   * Texto que acompanha a progress bar
   */
  label: _propTypes.default.string,

  /**
   * Texto que acompanha a progress bar embaixo
   */
  comment: _propTypes.default.string
};
ProgressBar.defaultProps = {
  color: 'primary',
  className: '',
  size: 'md',
  small: false,
  limit: false,
  label: null,
  comment: null
};
var _default = ProgressBar;
exports.default = _default;